import { myAxios } from "./axios";

export function getAdmins(payload, { page, limit }) {
  let config = {
    params: {
      page,
      limit,
      ...(payload || {}),
    },
  };
  return myAxios.get("/admins", config);
}

export const getUsers = (params = {}) => {
  return myAxios.get("/admins", {
    params,
  });
};

export function getAdminsDropdown(data, { page, limit }) {
  let config = {
    params: {
      page,
      limit,
      username: data ? data.txt : null,
    },
  };
  return myAxios.get("/dropdown/admins", config);
}

export function getMyAdmins(payload, { page, limit }) {
  let config = {
    params: {
      page,
      limit,
      roleId: payload,
    },
  };
  return myAxios.get("/admin/my-admins", config);
}
export function handleEdit(admin) {
  window.location.href = `/edit-admin/${admin._id}`;
}


export function addAdmin(data) {
  return myAxios.post("/admins", data);
}


export function editAdmin(id, data) {
  return myAxios.put("/admins/edit-admin/" + id, data);
}

export function getAdmin(id) {
  return myAxios.get("/admins/" + id);
}

export function deleteAdmin(id) {
  return myAxios.delete("/admins/delete/" + id);
}

export function changeAdminPassword(id, data) {
  return myAxios.put("/admins/" + id + "/change-password", data);
}

export function getProfile() {
  return myAxios.get("/admins/me");
}

export function editProfile(data) {
  return myAxios.post("/admins/edit-profile", data);
}



export function getLogs(_, { page, limit }) {
  let config = {
    params: {
      page,
      limit,
    },
  };
  return myAxios.get("/actionLogs", config);
}
